import React, { useEffect } from 'react'
import { useSelector } from "react-redux";
import { useNavigate, Link } from 'react-router-dom'

import CustomCard from '../../utils/components/CustomCard';
import { Box, Divider, Typography, Grid, Container, Breadcrumbs, Button } from '@mui/material';

const IndexPedidos = () => {
    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    useEffect(() => {
        if (auth.user.rol !== "Admin") {
            navigate('/dashboard');
        }
        document.title = 'Menú Principal';
    }, [auth])

    return (
        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            <Box className='text-center' >
                <Typography variant='h4' style={{ fontWeight: 700 }}>Pedidos (lotes)</Typography>
            </Box>
            <Button size='small' variant='outlined' onClick={() => navigate('/inventario')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
            <Divider variant="middle" className='my-3' />
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomCard
                        title="Agregar pedido"
                        to="/pedidos/agregarPedido"
                        button="Agregar"
                        cardIco="fad fa-plus fa-3x"
                        text="Agrega un nuevo Pedido."
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomCard
                        title="Ver pedidos"
                        to="/pedidos/verPedidos"
                        button="Pedidos"
                        cardIco="fad fa-ballot-check fa-3x"
                        text="Ver los pedidos creados."
                    />
                </Grid>
            </Grid>
            <br></br>
        </Container>
    )
}

export default IndexPedidos